import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyProductAddToSaveForLaterComponent } from './lazy-product-add-to-save-for-later/lazy-product-add-to-save-for-later.component';
import { LazySaveForLaterMessagesComponent } from './lazy-save-for-later-messages/lazy-save-for-later-messages.component';
import { LazySaveForLaterComponent } from './lazy-save-for-later/lazy-save-for-later.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'saveForLater',
        location: () => import('../store/save-for-later-store.module').then(m => m.SaveForLaterStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyProductAddToSaveForLaterComponent, LazySaveForLaterComponent, LazySaveForLaterMessagesComponent],
  exports: [LazyProductAddToSaveForLaterComponent, LazySaveForLaterComponent, LazySaveForLaterMessagesComponent],
})
export class SaveForLaterExportsModule {}
